// extracted by mini-css-extract-plugin
export default {"show":"AnimatedProductModelsPanel__show___JtxF2","hide":"AnimatedProductModelsPanel__hide___zU3AR"};